


























































































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Allies extends Vue {
  private mounted(): void {
    window.scrollTo(0, 0);
  }
}
